// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBox,
//   faIdBadge,
//   faTag,
//   faCogs,
//   faTruck,
//   faCalendarAlt,
//   faMoneyBillWave,
//   faSearch,
// } from "@fortawesome/free-solid-svg-icons";
// import "./InventoryDetail.css";
// import Navbar from "./common/Navbar";
// import Footer from "./common/Footer";
// import Sidebar from "./common/Sidebar";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const InventorySearch = () => {
//   const [itemID, setItemID] = useState("");
//   const [inventory, setInventory] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setInventory(null);

//     try {
//       const token = sessionStorage.getItem("token");
//       const response = await fetch(
//         `${BASE_URL}/api/inventory/getinventorydetail/${itemID}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           errorData.message || "Failed to fetch inventory details"
//         );
//       }

//       const data = await response.json();
//       setInventory(data);
//     } catch (error) {
//       setError(error.message || "Error fetching inventory details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="inventory-detail-app-container">
//       <Navbar />
//       <Sidebar />

//       <main className="inventory-detail-main-content">
//         <div className="inventory-detail-wrapper">
//           <div className="inventory-detail-header">
//             <h1 className="inventory-detail-title">
//               <span className="inventory-detail-title-highlight">
//                 Inventory
//               </span>{" "}
//               Details
//             </h1>
//             <p className="inventory-detail-subtitle">
//               Search for inventory items by their unique ID
//             </p>
//           </div>

//           <form onSubmit={handleSearch} className="inventory-detail-form">
//             <div className="inventory-detail-input-container">
//               <div className="inventory-detail-input-group">
//                 <input
//                   type="text"
//                   id="itemID"
//                   value={itemID}
//                   placeholder="Enter Item ID"
//                   onChange={(e) => setItemID(e.target.value)}
//                   required
//                   className="inventory-detail-input"
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="inventory-detail-button"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   "Searching..."
//                 ) : (
//                   <>
//                     <FontAwesomeIcon icon={faSearch} /> Search
//                   </>
//                 )}
//               </button>
//             </div>
//           </form>

//           {error && (
//             <div className="inventory-detail-error-message">
//               <p>{error}</p>
//             </div>
//           )}

//           {inventory && (
//             <div className="inventory-detail-results-container">
//               <div className="inventory-detail-card">
//                 <div className="inventory-detail-card-header">
//                   <h2>
//                     <FontAwesomeIcon icon={faBox} /> {inventory.itemName}
//                   </h2>
//                   <span className="inventory-detail-item-id">
//                     ID: {inventory.itemID}
//                   </span>
//                 </div>

//                 <div className="inventory-detail-card-body">
//                   <div className="inventory-detail-info-section">
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faTag}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Category
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           {inventory.category}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faCogs}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Brand/Model
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           {inventory.brandModel}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faTruck}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Supplier
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           {inventory.supplier}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="inventory-detail-info-section">
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faCalendarAlt}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Purchase Date
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           {new Date(
//                             inventory.purchaseDate
//                           ).toLocaleDateString()}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faCalendarAlt}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Warranty Expiry
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           {inventory.warrantyExpiryDate
//                             ? new Date(
//                                 inventory.warrantyExpiryDate
//                               ).toLocaleDateString()
//                             : "N/A"}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="inventory-detail-info-item">
//                       <FontAwesomeIcon
//                         icon={faMoneyBillWave}
//                         className="inventory-detail-info-icon"
//                       />
//                       <div>
//                         <span className="inventory-detail-info-label">
//                           Price
//                         </span>
//                         <span className="inventory-detail-info-value">
//                           ${inventory.price}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="inventory-detail-history-section">
//                 <h3 className="inventory-detail-section-title">
//                   <span>Assignment History</span>
//                 </h3>

//                 {inventory.assignmentHistory.length === 0 ? (
//                   <div className="inventory-detail-no-history">
//                     No assignment history available for this item.
//                   </div>
//                 ) : (
//                   <div className="inventory-detail-history-container">
//                     <table className="inventory-detail-history-table">
//                       <thead>
//                         <tr>
//                           <th>Assigned To</th>
//                           <th>Assigned By</th>
//                           <th>Assignment Date</th>
//                           <th>Return Date</th>
//                           <th>Condition</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {inventory.assignmentHistory
//                           .slice()
//                           .reverse()
//                           .map((assignment) => (
//                             <tr key={assignment._id}>
//                               <td data-label="Assigned To">
//                                 {assignment.assignedTo}
//                               </td>
//                               <td data-label="Assigned By">
//                                 {assignment.assignedBy}
//                               </td>
//                               <td data-label="Assignment Date">
//                                 {new Date(
//                                   assignment.assignmentDate
//                                 ).toLocaleDateString()}
//                               </td>
//                               <td data-label="Return Date">
//                                 {assignment.returnDate
//                                   ? new Date(
//                                       assignment.returnDate
//                                     ).toLocaleDateString()
//                                   : "N/A"}
//                               </td>
//                               <td data-label="Condition">
//                                 <span
//                                   className={`inventory-detail-condition-badge ${assignment.condition.toLowerCase()}`}
//                                 >
//                                   {assignment.condition}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </main>
//       <Footer />
//     </div>
//   );
// };

// export default InventorySearch;

import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Alert,
  Paper,
  InputAdornment,
  CircularProgress,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";
import {
  Search as SearchIcon,
  QrCode as QrCodeIcon,
  Inventory as InventoryIcon,
  Category as CategoryIcon,
  Business as BusinessIcon,
  LocalShipping as ShippingIcon,
  CalendarToday as CalendarIcon,
  CurrencyRupee as CurrencyIcon,
  Assignment as AssignmentIcon,
  Storage as StorageIcon,
  History as HistoryIcon,
} from "@mui/icons-material";
import PageContainer from "../common/PageContainer";
import PageHeader from "../common/PageHeader";
import EmptyState from "../common/EmptyState";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const InventorySearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("itemID");
  const [inventory, setInventory] = useState(null);
  const [inventoryList, setInventoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    // Clear all search results when changing search type
    setInventory(null);
    setInventoryList([]);
    setError(null);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setInventory(null);
    setInventoryList([]);

    try {
      const token = sessionStorage.getItem("token");
      let url;

      if (searchType === "itemID") {
        url = `${BASE_URL}/api/inventory/getinventorydetail/${searchTerm}`;
      } else {
        url = `${BASE_URL}/api/inventory/box/${searchTerm}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch inventory details"
        );
      }

      const data = await response.json();

      if (searchType === "itemID") {
        setInventory(data);
      } else {
        setInventoryList(data);
      }
    } catch (error) {
      setError(error.message || "Error fetching inventory details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <PageHeader
        gradient
        title="Inventory Search"
        subtitle="Search inventory items by Item ID or Box ID"
        icon={<SearchIcon />}
      />

      {/* Search Card */}
      <Paper
        elevation={0}
        sx={{
          border: "1px solid #eef0f6",
          borderRadius: "16px",
          overflow: "hidden",
          mb: 3,
        }}
      >
        {/* Gradient accent header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
            px: 3,
            py: 1.5,
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 600,
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <SearchIcon sx={{ fontSize: 18 }} />
            Find Inventory
          </Typography>
        </Box>

        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <form onSubmit={handleSearch}>
            {/* Search Type Toggle */}
            <Box sx={{ mb: 2.5, display: "flex", justifyContent: "center" }}>
              <ToggleButtonGroup
                value={searchType}
                exclusive
                onChange={(e, newValue) => {
                  if (newValue) handleSearchTypeChange(newValue);
                }}
                sx={{
                  "& .MuiToggleButtonGroup-grouped": {
                    border: "1px solid #eef0f6",
                    "&:not(:first-of-type)": { borderLeft: "1px solid #eef0f6" },
                  },
                  "& .MuiToggleButton-root": {
                    px: 3,
                    py: 1,
                    borderRadius: "10px !important",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    color: "#5a5f7a",
                    "&.Mui-selected": {
                      background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                      color: "#fff",
                      boxShadow: "0 4px 12px rgba(30, 60, 114, 0.3)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                      },
                    },
                  },
                }}
              >
                <ToggleButton value="itemID">
                  <QrCodeIcon sx={{ mr: 1, fontSize: 18 }} />
                  Item ID
                </ToggleButton>
                <ToggleButton value="boxID">
                  <StorageIcon sx={{ mr: 1, fontSize: 18 }} />
                  Box ID
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {/* Search Input */}
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems={{ sm: "center" }}
            >
              <TextField
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={`Enter ${searchType === "itemID" ? "Item ID" : "Box ID"}`}
                required
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {searchType === "itemID" ? (
                        <QrCodeIcon sx={{ color: "#667eea", fontSize: 20 }} />
                      ) : (
                        <StorageIcon sx={{ color: "#667eea", fontSize: 20 }} />
                      )}
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    bgcolor: "#f5f7fb",
                    fontSize: "0.875rem",
                    "& fieldset": { borderColor: "#eef0f6" },
                    "&:hover fieldset": { borderColor: "#667eea" },
                    "&.Mui-focused fieldset": { borderColor: "#667eea" },
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    <SearchIcon sx={{ fontSize: 18 }} />
                  )
                }
                sx={{
                  px: 3.5,
                  py: 1,
                  borderRadius: "50px",
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  textTransform: "none",
                  background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #667eea 100%)",
                  boxShadow: "0 4px 15px rgba(30, 60, 114, 0.3)",
                  minWidth: 130,
                  whiteSpace: "nowrap",
                  "&:hover": {
                    background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #667eea 100%)",
                    boxShadow: "0 6px 20px rgba(30, 60, 114, 0.45)",
                    transform: "translateY(-1px)",
                  },
                  "&:disabled": {
                    background: "#e8eaf6",
                    color: "#8b8fa3",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {loading ? "Searching..." : "Search"}
              </Button>
            </Stack>
          </form>
        </Box>
      </Paper>

      {/* Loading State */}
      {loading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 8,
          }}
        >
          <CircularProgress size={40} sx={{ color: "#667eea", mb: 2 }} />
          <Typography sx={{ color: "#8b8fa3", fontSize: "0.875rem" }}>
            Searching inventory...
          </Typography>
        </Box>
      )}

      {/* Error State */}
      {error && (
        <Alert
          severity="error"
          sx={{
            borderRadius: "12px",
            mb: 3,
            border: "1px solid #fecaca",
            "& .MuiAlert-message": {
              fontWeight: 500,
              fontSize: "0.875rem",
              color: "#1a1a2e",
            },
          }}
        >
          {error}
        </Alert>
      )}

      {/* No results state (only show after a search completes with no results and no error) */}
      {!loading && !error && !inventory && inventoryList.length === 0 && searchTerm && (
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #eef0f6",
            borderRadius: "16px",
          }}
        >
          <EmptyState
            icon={<SearchIcon sx={{ fontSize: 30 }} />}
            title="No results found"
            subtitle={`No inventory items found for the given ${searchType === "itemID" ? "Item ID" : "Box ID"}. Please check the ID and try again.`}
          />
        </Paper>
      )}

      {/* Display single inventory item (Item ID search) */}
      {inventory && (
        <Box>
          {/* Item Detail Card */}
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #eef0f6",
              borderRadius: "16px",
              overflow: "hidden",
              mb: 3,
            }}
          >
            {/* Item Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #667eea 100%)",
                color: "#fff",
                px: 3,
                py: 2.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  fontWeight: 700,
                  fontSize: { xs: "1.05rem", sm: "1.25rem" },
                }}
              >
                <InventoryIcon sx={{ fontSize: 22 }} />
                {inventory.itemName}
              </Typography>
              <Chip
                label={`ID: ${inventory.itemID}`}
                size="small"
                sx={{
                  bgcolor: "rgba(255,255,255,0.18)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  backdropFilter: "blur(8px)",
                }}
              />
            </Box>

            {/* Item Details */}
            <Box sx={{ p: { xs: 2.5, sm: 3.5 } }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Stack spacing={2.5}>
                    {[
                      { icon: <CategoryIcon />, label: "Category", value: inventory.category },
                      { icon: <BusinessIcon />, label: "Brand/Model", value: inventory.brandModel },
                      { icon: <ShippingIcon />, label: "Supplier", value: inventory.supplier },
                    ].map((field) => (
                      <Box
                        key={field.label}
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "10px",
                            bgcolor: "#f0f0ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#667eea",
                            fontSize: 18,
                            flexShrink: 0,
                          }}
                        >
                          {field.icon}
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#8b8fa3",
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {field.label}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              color: "#1a1a2e",
                              fontWeight: 600,
                            }}
                          >
                            {field.value}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Stack spacing={2.5}>
                    {[
                      {
                        icon: <CalendarIcon />,
                        label: "Purchase Date",
                        value: new Date(inventory.purchaseDate).toLocaleDateString(),
                      },
                      {
                        icon: <CalendarIcon />,
                        label: "Warranty Expiry",
                        value: inventory.warrantyExpiryDate
                          ? new Date(inventory.warrantyExpiryDate).toLocaleDateString()
                          : "N/A",
                      },
                      {
                        icon: <CurrencyIcon />,
                        label: "Price",
                        value: `₹${inventory.price}`,
                      },
                    ].map((field) => (
                      <Box
                        key={field.label}
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "10px",
                            bgcolor: "#f0f0ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#667eea",
                            fontSize: 18,
                            flexShrink: 0,
                          }}
                        >
                          {field.icon}
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#8b8fa3",
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {field.label}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              color: "#1a1a2e",
                              fontWeight: 600,
                            }}
                          >
                            {field.value}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Paper>

          {/* Assignment History Section */}
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #eef0f6",
              borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                px: 3,
                py: 2,
                borderBottom: "2px solid #f0f0f5",
                bgcolor: "#f5f7fb",
              }}
            >
              <Typography
                sx={{
                  color: "#1a1a2e",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                }}
              >
                <HistoryIcon sx={{ color: "#667eea", fontSize: 20 }} />
                Assignment History
              </Typography>
            </Box>

            {inventory.assignmentHistory.length === 0 ? (
              <EmptyState
                icon={<HistoryIcon sx={{ fontSize: 30 }} />}
                title="No assignment history"
                subtitle="No assignment history available for this item."
              />
            ) : (
              <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {["ASSIGNED TO", "ASSIGNED BY", "ASSIGNMENT DATE", "RETURN DATE", "CONDITION"].map(
                        (header) => (
                          <TableCell
                            key={header}
                            sx={{
                              bgcolor: "#f5f7fb",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              color: "#5a5f7a",
                              letterSpacing: "0.05em",
                              textTransform: "uppercase",
                              borderBottom: "2px solid #f0f0f5",
                              whiteSpace: "nowrap",
                              py: 1.5,
                            }}
                          >
                            {header}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inventory.assignmentHistory
                      .slice()
                      .reverse()
                      .map((assignment) => (
                        <TableRow
                          key={assignment._id}
                          sx={{
                            "&:hover": { bgcolor: "#f5f7fb" },
                            "& td": {
                              borderBottom: "1px solid #f0f2f8",
                              fontSize: "0.875rem",
                              color: "#1a1a2e",
                            },
                          }}
                        >
                          <TableCell sx={{ fontWeight: 600 }}>
                            {assignment.assignedTo}
                          </TableCell>
                          <TableCell>{assignment.assignedBy}</TableCell>
                          <TableCell>
                            {new Date(assignment.assignmentDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {assignment.returnDate
                              ? new Date(assignment.returnDate).toLocaleDateString()
                              : (
                                <Chip
                                  label="Not Returned"
                                  size="small"
                                  sx={{
                                    bgcolor: "#FEF3C7",
                                    color: "#92400E",
                                    fontWeight: 600,
                                    fontSize: "0.75rem",
                                    height: 24,
                                  }}
                                />
                              )}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={assignment.condition}
                              size="small"
                              sx={{
                                fontWeight: 600,
                                fontSize: "0.75rem",
                                height: 24,
                                bgcolor:
                                  assignment.condition.toLowerCase() === "excellent" || assignment.condition === "1"
                                    ? "#dcfce7"
                                    : assignment.condition.toLowerCase() === "good" || assignment.condition === "2"
                                    ? "#dbeafe"
                                    : assignment.condition.toLowerCase() === "fair" || assignment.condition === "3"
                                    ? "#FEF3C7"
                                    : "#fee2e2",
                                color:
                                  assignment.condition.toLowerCase() === "excellent" || assignment.condition === "1"
                                    ? "#166534"
                                    : assignment.condition.toLowerCase() === "good" || assignment.condition === "2"
                                    ? "#1e40af"
                                    : assignment.condition.toLowerCase() === "fair" || assignment.condition === "3"
                                    ? "#92400E"
                                    : "#991b1b",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Box>
      )}

      {/* Display multiple inventory items (Box ID search) */}
      {inventoryList.length > 0 && (
        <Box>
          {/* Box Header */}
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #eef0f6",
              borderRadius: "16px",
              px: 3,
              py: 2,
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#f0f0ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#667eea",
                }}
              >
                <StorageIcon sx={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography
                  sx={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a2e" }}
                >
                  Box ID: {searchTerm}
                </Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "#8b8fa3" }}>
                  {inventoryList.length} item{inventoryList.length !== 1 ? "s" : ""} found
                </Typography>
              </Box>
            </Box>
            <Chip
              label={`${inventoryList.length} items`}
              size="small"
              sx={{
                bgcolor: "#f0f0ff",
                color: "#667eea",
                fontWeight: 600,
                fontSize: "0.75rem",
              }}
            />
          </Paper>

          {/* Box Items Grid */}
          <Grid container spacing={2.5}>
            {inventoryList.map((item) => (
              <Grid item xs={12} md={6} lg={4} key={item._id}>
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #eef0f6",
                    borderRadius: "16px",
                    overflow: "hidden",
                    height: "100%",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      borderColor: "#667eea",
                      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.12)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  {/* Card Header */}
                  <Box
                    sx={{
                      background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                      color: "#fff",
                      px: 2.5,
                      py: 1.5,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontWeight: 700,
                        fontSize: "0.9rem",
                      }}
                    >
                      <InventoryIcon sx={{ fontSize: 18 }} />
                      {item.itemName}
                    </Typography>
                    <Chip
                      label={item.itemID}
                      size="small"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.18)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.7rem",
                        height: 22,
                      }}
                    />
                  </Box>

                  {/* Card Body */}
                  <Box sx={{ p: 2.5 }}>
                    <Stack spacing={2}>
                      {[
                        { icon: <CategoryIcon sx={{ fontSize: 16 }} />, label: "Category", value: item.category },
                        { icon: <BusinessIcon sx={{ fontSize: 16 }} />, label: "Brand/Model", value: item.brandModel },
                      ].map((field) => (
                        <Box
                          key={field.label}
                          sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                        >
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              borderRadius: "8px",
                              bgcolor: "#f0f0ff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#667eea",
                              flexShrink: 0,
                            }}
                          >
                            {field.icon}
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.65rem",
                                color: "#8b8fa3",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                              }}
                            >
                              {field.label}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.8rem",
                                color: "#1a1a2e",
                                fontWeight: 600,
                              }}
                            >
                              {field.value}
                            </Typography>
                          </Box>
                        </Box>
                      ))}

                      {/* Status */}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box
                          sx={{
                            width: 30,
                            height: 30,
                            borderRadius: "8px",
                            bgcolor: "#f0f0ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#667eea",
                            flexShrink: 0,
                          }}
                        >
                          <AssignmentIcon sx={{ fontSize: 16 }} />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.65rem",
                              color: "#8b8fa3",
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            Status
                          </Typography>
                          <Chip
                            label={item.status}
                            size="small"
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              height: 22,
                              mt: 0.25,
                              bgcolor:
                                item.status === "In Stock"
                                  ? "#dcfce7"
                                  : item.status === "Assigned"
                                  ? "#dbeafe"
                                  : item.status === "Maintenance"
                                  ? "#FEF3C7"
                                  : "#f5f7fb",
                              color:
                                item.status === "In Stock"
                                  ? "#166534"
                                  : item.status === "Assigned"
                                  ? "#1e40af"
                                  : item.status === "Maintenance"
                                  ? "#92400E"
                                  : "#5a5f7a",
                            }}
                          />
                        </Box>
                      </Box>

                      {/* Price */}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box
                          sx={{
                            width: 30,
                            height: 30,
                            borderRadius: "8px",
                            bgcolor: "#f0f0ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#667eea",
                            flexShrink: 0,
                          }}
                        >
                          <CurrencyIcon sx={{ fontSize: 16 }} />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.65rem",
                              color: "#8b8fa3",
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            Price
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              color: "#1a1a2e",
                              fontWeight: 600,
                            }}
                          >
                            ₹{item.price}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </PageContainer>
  );
};

export default InventorySearch;
